import { Injectable, Injector } from '@angular/core';
import { NavigationScreensService } from '../manageb/navigation-screens.service';
import { ServerService } from '../services/server.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { User, UserToken, PersonalInfo } from '../models/user';
import { UserService } from '../services/user.service';
import { Route, Router } from '@angular/router';
import { ServerTokenService } from '../services/server-token.service';
import { environment } from '../environment/environment';
import { PatientsFilters } from '../manageb/previous-cases/previous-cases-filters/previous-cases-filters.interface';
import { UiSettings, UserSettings } from 'list-types-public';
import { Location } from '@angular/common';
import { clearSessionDateFilters } from '../manageb/previous-cases/previous-cases-filters/previous-cases-filters.util';
// import * as Sentry from "@sentry/angular-ivy";

@Injectable({
  providedIn: 'root',
})

// tslint:disable:no-console
export class CustomAuthServiceService {

  private authStateSubject = new BehaviorSubject<boolean>(false);
  authState$ = this.authStateSubject.asObservable();

  setFakeUser() {
  }


  private currentUserName: string

  getUserName() {
    if(localStorage.getItem('currentUser')) {
      return JSON.parse(localStorage.getItem('currentUser')).fullName || ''
    }
    return '';
  }
  updateUser(user: UserToken) {
    console.log('CustomAuthServiceService updateUser', user)
    this.currentUserSubject = user;
  }

  updateInvestorInfo(user: User): Observable<User> {
    return new Observable<User>(subscribe => {
      this.userServices.updateInvestorInfo(user).subscribe(data => {
        console.log('CustomAuthServiceService updateInvestorInfo', data)
        this.currentUserSubject.user = data;
        localStorage.setItem('currentUser', JSON.stringify(this.currentUserSubject));
        subscribe.next(data);
      });
    });

  }

  updatePatientsFilters(patientsFilters: PatientsFilters): void {
    const currentSettings = this.currentUserSubject.settings ?? { patientsFilters, facilities: [], allFacilities: true };
    console.log('CustomAuthServiceService updatePatientsFilters', currentSettings)
    this.currentUserSubject.settings = { ...currentSettings, patientsFilters };
    localStorage.setItem('currentUser', JSON.stringify(this.currentUserSubject));
  }

  updatePatientDefaults(def: any) {
    const currentSettings = this.currentUserSubject.settings?.defaultFields ?? {  };
    this.currentUserSubject.settings.defaultFields =  { ...currentSettings, ...def };
    localStorage.setItem('currentUser', JSON.stringify(this.currentUserSubject));
  }

  updateUserUiSettings(uiSettings: Partial<UiSettings> & { defaultScreen?: string }) {
    if (!this.currentUserSubject.settings) {
      this.currentUserSubject.settings = {} as UserSettings;
    }
    const currentSettings = this.currentUserSubject.settings.uiSettings ?? {};
    this.currentUserSubject.settings.uiSettings = {
      ...currentSettings,
      ...uiSettings,
    } as UiSettings & { defaultScreen?: string };
    localStorage.setItem('currentUser', JSON.stringify(this.currentUserSubject));
  }

  get legacyNavigation(): boolean {
    return this.currentUserSubject?.settings?.uiSettings?.legacyNavigation === true;
  }

  saveLoginUser(user: UserToken | any) {
    this.expirationTime = new Date(user.expirationTime);
    localStorage.setItem('currentUser', JSON.stringify(user));
    localStorage.setItem('expirationTime', this.expirationTime.toISOString());
    const v: HTMLIFrameElement = document.getElementById('loginIframe') as HTMLIFrameElement;
    v.contentWindow.
      postMessage({ firstName: user.user.firstName, lastName: user.user.lastName, token: user.token, userObj: user }, '*');

    if (user.user && user.role > 30) {
      console.log('CustomAuthServiceService saveLoginUser', user)
      this.currentUserSubject = user
    }
  }

  updateLoginUser(user: UserToken | any) {
    this.expirationTime = new Date(user.expirationTime);
    localStorage.setItem('currentUser', JSON.stringify({ ...this.currentUserSubject, ...user }));
    localStorage.setItem('expirationTime', this.expirationTime.toISOString());
  }

  getSavedLoginUser() {

  }


  constructor(private service: ServerService,
    private router: Router,
    private userServices: UserService,
    private tokenServerService: ServerTokenService,
    private location: Location,
    private injector: Injector) {
    const tokenTime = localStorage.getItem('expirationTime');

    if (tokenTime) {
      const ex = new Date(tokenTime);
      if (ex.getTime() - Date.now() > 0 && localStorage.getItem('currentUser')) {
        try {
          console.log('CustomAuthServiceService getSavedLoginUser', localStorage.getItem('currentUser'))
          this.currentUserSubject = JSON.parse(localStorage.getItem('currentUser'));
          tokenServerService.setAuthToken(this.currentUserSubject.token);
          userServices.initUserToken(localStorage.getItem('currentUser'));
          this.authStateSubject.next(true);

        } catch (e) {
        }


      }
    }
  }

  private
  currentUserSubject: UserToken;
  expirationTime: Date;
  currentUserValue(): UserToken {
    try {
      console.log('CustomAuthServiceService currentUserValue', this.currentUserSubject)
      const cloned: UserToken = JSON.parse(JSON.stringify(this.currentUserSubject));
      // if (!cloned.user.personalInfo) { // TODO: check why is not created automaticly
      //   cloned.user.personalInfo = new PersonalInfo();
      // }
      return cloned;

    } catch (err) {
      return null;
    }
  }

  getToken() {
    return this.tokenServerService.authToken;
  }

  login(userName, password, returnUrl?: string | null): Observable<UserToken> {
    // const obs = new Observable<UserToken>(observer => {
     console.log('GOTO  GROM LOGIN')
    const obs = this.service.post<UserToken>('auth/login', { userName, password });
    obs.subscribe((data: any) => {
      console.log('BACK GROM LOGIN')
      this.tokenServerService.setAuthToken(data.token);
      this.currentUserSubject = data;

      this.currentUserName = data.fullName
      this.saveLoginUser(data);
      this.goToAfterLogin(data, returnUrl)
      // ( this.expirationTime.getDate() - Date.now()));
      // observer.next(data);
    }
      ,
      err => {
        console.log('err auth service', err);
        // observer.error(err);
      },
    );
    // });
    // obs.pipe(
    //   catchError(function(err, ff){
    //     return throwError('fasf');
    //   })
    // );
    return obs;

  }

  async validateOneTimeToken(token: string): Promise<boolean> {
    try {
      const response = await this.service.post<{ isValid: boolean }>('auth/login/token', { token }).toPromise();
      return response?.isValid || false;
    } catch (error) {
      console.log('err auth service', error);
    }
  }

  updatePassword(username, password, token?) {


    const obs = new Observable<UserToken>(observer => {
      if (token) {
        // tslint:disable-next-line:max-line-length
        this.service.post<UserToken>('manage/login/updatePassword', { username, newPassword: password, token: token, isAccredited: true }).subscribe(data => {
          this.currentUserSubject = data;
          this.saveLoginUser(data);
          this.tokenServerService.setAuthToken(data.token);
          observer.next(data);

        });
      } else {
        this.tokenServerService.postWithToken<UserToken>('manage/login/updatePassword',
          { username, newPassword: password, isAccredited: true }).subscribe(data => {
            this.currentUserSubject = data;
            this.saveLoginUser(data);
            this.tokenServerService.setAuthToken(data.token);
            observer.next(data);
          });

      }
    });
    return obs;
  }
  resetPassword(email) {
    // username, password, newPassword
    return this.service.post<UserToken>('manage/login/resetPassword',
      { email });
  }

  // Reject external/auth-flow paths; role access is left to route guards.
  private isSafeReturnUrl(returnUrl: string | null | undefined): boolean {
    if (!returnUrl || typeof returnUrl !== 'string') { return false; }
    if (!returnUrl.startsWith('/') || returnUrl.startsWith('//')) { return false; }
    if (returnUrl.startsWith('/auth')) { return false; }
    const APP_ROOTS = ['/manageb', '/client'];
    return APP_ROOTS.some(
      (root) => returnUrl === root || returnUrl.startsWith(root + '/') || returnUrl.startsWith(root + '?'),
    );
  }

  private effectiveRole(data: any): number {
    return data && data['contactAs'] ? data['contactAs'].roleNumber : data?.role;
  }

  // The role the app behaves as. While impersonating that is the contactAs role,
  // which is what login and the landing table key on, so guards and menus must
  // read it too or impersonation cannot reproduce a role's restrictions.
  effectiveRoleOf(user: any): number {
    return Number(this.effectiveRole(user));
  }

  // Some accounts store currentUser.user as the plain username string, not an object.
  // Without this the marker is always undefined for them and the same-user check is inert.
  private userMarker(user: any): string | undefined {
    if (typeof user === 'string') { return user || undefined; }
    return user?._id ?? user?.username ?? user?.email;
  }

  private storedUser(): any {
    try {
      return JSON.parse(localStorage.getItem('currentUser') || 'null');
    } catch {
      return null;
    }
  }

  // Restore only for the same user; no marker (fresh deep-link) -> allow.
  private returnUrlUserMatches(data: any): boolean {
    const ru = this.router.parseUrl(this.router.url).queryParams['ru'];
    if (!ru) { return true; }
    return String(ru) === String(this.userMarker(data?.user));
  }

  goToAfterLogin(data, returnUrl?: string | null) {
    this.authStateSubject.next(true);
    this.currentUserName = data.fullName;
    if (this.isSafeReturnUrl(returnUrl) && this.returnUrlUserMatches(data)) {
      this.location.replaceState('/manageb/dashboard');
      this.router.navigateByUrl(returnUrl).then(
        (ok) => { if (!ok) { this.navigateByRole(this.effectiveRole(data)); } },
        () => { this.navigateByRole(this.effectiveRole(data)); },
      );
      return;
    }
    // Sentry.captureMessage(`${this.currentUserName} logged in with role ${data.role}`);
    const effectiveRole = Number(data['contactAs'] ? data['contactAs'].roleNumber : data.role);
    const defaultScreen = data?.settings?.uiSettings?.defaultScreen;
    if (defaultScreen && this.injector.get(NavigationScreensService).isLandingScreenAllowed(effectiveRole, defaultScreen)) {
      // A saved defaultScreen can point at a route that no longer exists (renamed or
      // typo'd when it was stored); without the fallback that navigation just fails
      // and leaves an empty outlet.
      this.router.navigateByUrl(defaultScreen).then(
        (ok) => { if (!ok) { this.navigateByRole(effectiveRole); } },
        () => { this.navigateByRole(effectiveRole); },
      );
      return;
    }
    let role = Number(data.role)
    if(data['contactAs']){
    this.navigateByRole(data['contactAs'].roleNumber)
    }else{
      this.navigateByRole(data.role)
    }
    // if ((data.role > 700 && data.role < 1000) || data.role == 100) {
    //   this.router.navigateByUrl('manage/upload');
    // } else if (data.role > 500 && data.role <= 700) {
    //   this.router.navigateByUrl('manage/underwriting');
    // } else if (data.role > 400 && data.role <= 500) {
    //   this.router.navigateByUrl('manage/pricing');
    // } else if (data.role > 30 && data.role <= 32) {
    //   this.router.navigateByUrl('manage/upload')
    // }
    return;
    setTimeout(() => {
      if (data.changePassword) {
        this.router.navigateByUrl('/auth/update-password');
      } else if (data.user.role === 'superAdmin') {
        this.router.navigateByUrl('manage/assets');
      } else if (data.user.role === 'financeAdmin') {
        this.router.navigateByUrl('calculations');
      } else if (data.user.role === 'admin') {
        this.router.navigateByUrl('manage/contacts');
      } else if (data.user.role === 'investor') {
        this.router.navigateByUrl('manage/assets');
      } else {
        this.router.navigateByUrl('manage/upload');
      }
    }, 1);
  }

  // Logo/home click: send the user to their saved default screen (validated for their effective
  // role), falling back to role-based landing. Mirrors post-login resolution in goToAfterLogin.
  goToDefaultScreen() {
    const url = this.resolveLandingUrl();
    if (url) { this.router.navigateByUrl(url); }
  }

  // Where this user belongs, as a URL rather than a navigation. The '**' fallback needs the
  // target up front so it can tell "redirect there" from "that is where we already are".
  resolveLandingUrl(): string | null {
    const data: any = this.currentUserValue();
    if (!data) { return null; }
    const effectiveRole = this.effectiveRole(data);
    const defaultScreen = data?.settings?.uiSettings?.defaultScreen;
    if (defaultScreen && this.injector.get(NavigationScreensService)
        .isLandingScreenAllowed(Number(effectiveRole), defaultScreen)) {
      return defaultScreen;
    }
    return this.landingUrlForRole(effectiveRole);
  }

  navigateByRole(role) {
    this.router.navigateByUrl(this.landingUrlForRole(role));
  }

  // The role -> landing table lives in NavigationScreensService so the profile picker's
  // "(default)" marker and this redirect can never disagree. An unmapped role used to fall
  // through here with no navigation at all, which reads as a white screen; it now lands
  // somewhere. Route guards still decide what the user may actually open.
  landingUrlForRole(roleValue): string {
    return NavigationScreensService.defaultPathForRole(Number(roleValue));
  }

  // preserveReturn=false for a voluntary "Log Out" — only session-expiry should reopen the last
  // page on relogin. Restoring it after a deliberate logout is a shared-workstation privacy leak.
  // targetUrl for a guard that rejects before navigation commits: router.url is still the page
  // the user is leaving, so without it relogin reopens the wrong page.
  goToLogin(message?: string, preserveReturn: boolean = true, targetUrl?: string) {
    console.log('CustomAuthServiceService goToLogin')
    const returnUrl = targetUrl || this.router.url;
    // An expired session never populated currentUserSubject, and without a marker the
    // returnUrl is restored for whoever logs in next.
    const ru = this.userMarker(this.currentUserSubject?.user ?? this.storedUser()?.user); // read before clear
    this.currentUserSubject = null
    // nav.* keys are per-browser UI state (welcome seen, recents, rail). Clearing them re-shows the
    // New Navigation welcome dialog on every login, so they survive logout by design.
    const navState = Object.keys(localStorage)
      .filter((key) => key.startsWith('nav.'))
      .map((key) => [key, localStorage.getItem(key)] as const);
    localStorage.clear();
    clearSessionDateFilters();
    navState.forEach(([key, value]) => localStorage.setItem(key, value));
    // Without this, authState$ stays true across an SPA logout and the next login's `true` is a
    // repeat value - every distinctUntilChanged consumer keeps the previous user's derived state.
    this.authStateSubject.next(false);
    const queryParams: any = {};
    // A returnUrl pointing back at /auth is a second redirect stacking on the first. Writing it
    // buries the real page one nesting level deeper on every pass, and login rejects it anyway.
    if (preserveReturn && this.isSafeReturnUrl(returnUrl)) {
      queryParams.returnUrl = returnUrl;
      if (ru) { queryParams.ru = ru; }
    }
    if (message) { queryParams.message = message; }
    this.router.navigate(['/auth/login'], { queryParams });
  }

  isLoggedIn() {
    // localStorage.setItem('currentUser', JSON.stringify(user));
    // localStorage.setItem('expirationTime', this.expirationTime.toISOString());

    const user = localStorage.getItem('currentUser');
    const tokenTime = localStorage.getItem('expirationTime');
    return user && tokenTime && new Date(tokenTime).getTime() - Date.now() > 0;
  }

}
